// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider_wDwlb","cancelBtn":"cancelBtn_2ugUk"};